import { Injectable } from '@angular/core';
import { OrderShoppingTransportSelectionView } from '../views';
@Injectable()
export class OrderShoppingSearchNotifierService {
    search: (shoppingSelections: OrderShoppingTransportSelectionView[]) 
        => void = (shoppingSelections: OrderShoppingTransportSelectionView[]) => { };   
}